/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface SafetyWarning
 */
export interface SafetyWarning {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    severity?: string;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the SafetyWarning interface.
 */
export function instanceOfSafetyWarning(value: object): value is SafetyWarning {
    return true;
}

export function SafetyWarningFromJSON(json: any): SafetyWarning {
    return SafetyWarningFromJSONTyped(json, false);
}

export function SafetyWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafetyWarning {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function SafetyWarningToJSON(json: any): SafetyWarning {
    return SafetyWarningToJSONTyped(json, false);
}

export function SafetyWarningToJSONTyped(value?: SafetyWarning | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'title': value['title'],
        'description': value['description'],
        'severity': value['severity'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

